const updateActiveCard = (card) => {
  return { type: "UPDATE_ACTIVE_CARD", payload: card };
};

export default updateActiveCard;
